const OPEN_FREE_MAP_STYLE_BASE_URL = "https://tiles.openfreemap.org/styles" as const;

export const DEFAULT_MAP_CENTER = {
  latitude: 50.4501,
  longitude: 30.5234,
} as const;

export const getOpenFreeMapStyleUrl = (isDark: boolean) =>
  `${OPEN_FREE_MAP_STYLE_BASE_URL}/${isDark ? "dark" : "positron"}`;
